"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3409],{

/***/ 53409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var NXTImg = function(param) {
    var src = param.src, alt = param.alt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: src,
            layout: "fill",
            placeholder: "blur",
            blurDataURL: src,
            className: "block border-0 max-w-full h-full w-full object-cover object-[50%,50%] group-hover:scale-125 duration-[400ms] ease-in-out",
            alt: alt,
            priority: true
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NXTImg);


/***/ })

}]);